import React from "react";
import Sidebar from "./Sidebar";
import "./Dashboard.css";
import { Outlet, Link, useLocation } from "react-router-dom"; // 🔹 Link əlavə edirik
import DashboardHome from "./DashboardHome";

const AdminDashboard = () => {

    const location = useLocation(); // 🔥 URL-i almaq üçün

    const isDashboardHome = location.pathname === "/dashboard"; // 🔥 Yalnız /dashboard səhifəsi üçün yoxla

    return (
        <div className="admin-dashboard">
            <Sidebar />
            <div className="dashboard-content">
                {/* 🔹 Üst hissə - Admin Panel başlığı və Sayta keçid düyməsi */}
                <div className="dashboard-header">
                    <h1>Admin Panel</h1>
                       <Link to="/" className="go-to-site">🌐 Sayta keçid</Link>
                </div>

                {/* 🔹 Bura isə aşağıdakı dəyişən content üçün Outlet */}
                <Outlet />
                {isDashboardHome && <DashboardHome/>}
            </div>
        </div>
    );
};

export default AdminDashboard;
